export const deriveStateFromConfig = (config) => {
    return (config ?? []).map((mapSwitcherLayerConfig) => ({
        ...mapSwitcherLayerConfig,
        image: mapSwitcherLayerConfig.image ?? '',
    }));
};
//# sourceMappingURL=config.js.map